import { observer } from 'mobx-react-lite'
import { TbBuildingFactory, TbBuildingFactory2, TbBuildingOff } from 'react-icons/tb'

import { RelatedRecords } from '../../Components/RelatedRecords/RelatedRecords'
import { ResourceViewFields } from '../../Components/ResourceViewFields/ResourceViewFields'
import { useRelatedRecords } from '../../Hooks/useRelatedRecords'
import { ListConstructionObjectResource } from '../../Resources/ListConstructionObjectResource'
import { ListProductionObjectResource } from '../../Resources/ListProductionObjectResource'

/**
 * Картка регіону (перегляд): поля довідника і під ними дві секції — об'єкти виробництва
 * та будівництва цього регіону; клік по плитці відкриває картку об'єкта.
 * Іконки — ті самі, що в огляді довідників.
 */
export const RegionViewTemplate = observer(({ crudContext, formContext }: any) => {
    const code = formContext?.values?.code
    const productionObjects = useRelatedRecords('/services/lists/production-objects', 'region', code)
    const constructionObjects = useRelatedRecords('/services/lists/construction-objects', 'region', code)

    return (
        <>
            <ResourceViewFields crudContext={crudContext} formContext={formContext} />
            <RelatedRecords
                title="Об'єкти виробництва"
                state={productionObjects}
                resource={ListProductionObjectResource}
                icon={TbBuildingFactory2}
                inactiveIcon={TbBuildingOff}
                emptyText="У регіоні ще немає об'єктів виробництва"
            />
            <RelatedRecords
                title="Об'єкти будівництва"
                state={constructionObjects}
                resource={ListConstructionObjectResource}
                icon={TbBuildingFactory}
                inactiveIcon={TbBuildingOff}
                emptyText="У регіоні ще немає об'єктів будівництва"
            />
        </>
    )
})
